import styled from "styled-components"
import { useDispatch } from 'react-redux'
import TabSide from '../../components/messageAndNotifications/TabSide'
import MessageSide from '../../components/messageAndNotifications/MessageSide'
import { useEffect } from 'react'
import { getClosedChats, getNonClosedChats } from '../../features/messages/messageSlice'

const Container = styled.div`

width: 100%;

    .wrapper{
      display: flex;
      justify-content: space-between;
      padding: 30px;
    }
`

const Messages = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getClosedChats())
    dispatch(getNonClosedChats())
  }, [])

  return (
    <Container>
      <div className="wrapper">
        <TabSide />
        <MessageSide />
      </div>
    </Container>
  )
}

export default Messages